import { render, staticRenderFns } from "./HomeTopCollectionsCarousel.vue?vue&type=template&id=221bc91c&scoped=true"
import script from "./HomeTopCollectionsCarousel.vue?vue&type=script&lang=js"
export * from "./HomeTopCollectionsCarousel.vue?vue&type=script&lang=js"
import style0 from "./HomeTopCollectionsCarousel.vue?vue&type=style&index=0&id=221bc91c&prod&scoped=true&lang=css"
import style1 from "./HomeTopCollectionsCarousel.vue?vue&type=style&index=1&id=221bc91c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bc91c",
  null
  
)

export default component.exports